import React from "react";
import { NavLink } from "react-router-dom";
import RP_Avatar from "../RP_Avatar";

export const CardAdmin = ({ admin, getSelected }) => {
  return (
    <div className="w-full max-w-sm flex-1 rounded-2xl border border-wa-border bg-wa-panel p-5 shadow-[0_22px_48px_-36px_rgba(0,0,0,0.55)] transition hover:border-wa-accent/35 hover:bg-wa-panel2/90">
      <div className="flex flex-col items-center text-center">
        <RP_Avatar avatar={admin?.avatar} size={24} alt="Specialist" />

        <h5 className="mt-3 text-xl font-semibold text-wa-text">
          {admin?.full_name}
        </h5>
        <span className="mt-1 text-sm text-wa-muted">
          {admin?.beroep || "..."}
        </span>
        <div className="mt-3 space-y-1">
          <div className="text-xs text-wa-muted">
            tel: {admin?.phone_number || "0x xxx xx xx"}
          </div>
          <div className="text-xs text-wa-muted">
            email: {admin?.email || "..."}
          </div>
        </div>
        <div className="mt-5 flex w-full flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={() => getSelected(admin)}
            className="inline-flex min-h-[2.5rem] items-center justify-center rounded-lg bg-wa-accent px-3 py-2 text-sm font-semibold text-wa-onaccent transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
          >
              Maak een afspraak
          </button>
          <NavLink
            to="/mailbox"
            className="inline-flex min-h-[2.5rem] items-center justify-center rounded-lg border border-wa-border bg-wa-panel2 px-3 py-2 text-sm font-semibold text-wa-text transition hover:border-wa-accent/40 hover:bg-wa-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
          >
              Stuur een mail
          </NavLink>
        </div>
      </div>
    </div>
  );
};
